module.exports={
    primary:"#5B27D5",

}